import JwtServiceDefault from "@/services/_bit/JwtService";

class JwtService extends JwtServiceDefault {
  // You can redefine some part of default class here
}

export default new JwtService();
